import Vue from 'vue'
import Router from 'vue-router'
import {scrollTop} from '@/util'

Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    meta: {
      title: '首 页'
    },
    children: [
      {
        path: '',
        name: 'home',
        title: '首 页',
        content: null,
        component: () => import('@/views/Home')
      }
    ],
    component: {
      render: c => c("router-view")
    }
  },
  {
    path: '/contactUs',
    meta: {
      title: '联系我们'
    },
    children: [
      {
        path: '',
        name: 'ContactUs',
        title: '联系我们',
        content: null,
        component: () => import('@/views/ContactUs')
      }
    ],
    component: {
      render: c => c("router-view")
    }
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.afterEach(scrollTop)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js